export default "__VITE_ASSET__eef1344f__"